import React, { useState } from "react";
import PreAssessmentChatbotConversation from "./PreAssessmentChatbotConversation/PreAssessmentChatbotConversation";
import { SYSTEM_PROMPT } from "./preAssessmentChatbotUtil";
import { getLLResponse } from "@workspace/common/src/helpers/backend_helper";
import {
  generateJobInterviewQns,
  parseHtmlToText,
} from "./preAssessmentChatbotUtil";
import { toast } from "react-toastify";

const PreAssessmentQuestionChatbot = ({
  jobDescription,
  setPreAssessmentData,
}) => {
  const [input, setInput] = useState("");
  const [conversations, setConversations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSendMessage = async (manualInput = null) => {
    if (!manualInput) {
      setInput("");
    }

    if (!manualInput) {
      setConversations((prev) => [...prev, { type: "human", message: input }]);
    } else {
      setConversations((prev) => [
        ...prev,
        { type: "human", message: manualInput, hide: true },
      ]);
    }

    if (!jobDescription) {
      toast.error("Please enter a valid job description");
      return;
    }

    const llmRequest = generateJobInterviewQns(
      SYSTEM_PROMPT,
      parseHtmlToText(jobDescription),
      3,
      true,
      {
        field: "message_log",
        messageLog: conversations || [],
      },
      {
        input: manualInput || input,
        field: "user_input",
      }
    );

    let botResponse = null;
    try {
      setIsLoading(true);
      const response = await getLLResponse(llmRequest);
      botResponse = response;
      if (!botResponse) {
        toast.error("Failed to generate questions. Please try again.");
        return;
      }

      if (
        !botResponse?.interviewQuestions ||
        (botResponse?.interviewQuestions &&
          botResponse?.interviewQuestions.length === 0)
      ) {
        setConversations((prev) => [
          ...prev,
          { type: "bot", message: botResponse?.response },
        ]);
      } else {
        setConversations((prev) => [
          ...prev,
          {
            type: "bot",
            message: botResponse?.response,
            data: {
              questions: botResponse?.interviewQuestions,
            },
          },
        ]);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to generate questions: " + error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="d-flex flex-column"
      style={{
        borderLeft: "1px solid #e5e5e5",
        height: "100%",
        boxShadow: "0px 0px 5px 0px #e5e5e5",
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
      }}
    >
      <div
        className="d-flex justify-content-between"
        style={{
          fontSize: "1.2rem",
          padding: "10px 12.5px",
          backgroundColor: "#0A65CC",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          color: "#FFFFFF",
        }}
      >
        <span>Welcome to Anvy!</span>
        <i
          className=" ri-close-line"
          style={{
            cursor: "pointer",
            color: "#FFFFFF",
          }}
        ></i>
      </div>
      {/* // Main Content */}
      <div
        className="flex-grow-1 p-3"
        style={{
          overflowY: "auto",
          height: "100%",
        }}
      >
        <div
          className="p-2 fw-semibold mb-3"
          style={{
            backgroundColor: "#FFFFFF",
            color: "#0063B5",
            border: "1px solid #D7EDFF",
            borderRadius: "5px",
          }}
        >
          I am a chatbot here to help you with your pre-assessment questions.
          How may i help you?
        </div>

        <PreAssessmentChatbotConversation
          isLoading={isLoading}
          conversations={conversations}
          setPreAssessmentData={setPreAssessmentData}
          onNextQuestion={handleSendMessage}
        />
      </div>

      {/* // Input */}
      <div
        className="d-flex align-items-center gap-2"
        style={{
          backgroundColor: "#FFFFFF",
          padding: "10px 15px",
          borderTop: "2px solid #e5e5e5",
          width: "100%",
        }}
      >
        <div
          className="flex-grow-1"
          style={{
            position: "relative",
          }}
        >
          <input
            type="text"
            style={{
              height: "40px",
              padding: "0 10px",
              borderRadius: "100vh",
              width: "100%",
              paddingRight: "40px",
            }}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSendMessage();
              }
            }}
          />
          <i
            className=" ri-send-plane-fill"
            style={{
              position: "absolute",
              right: "15px",
              color: "#0A4FAE",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              fontSize: "1.2rem",
            }}
            onClick={() => handleSendMessage()}
          ></i>
        </div>
        <i className="ri-restart-line fs-4 cursor-pointer"></i>
      </div>
    </div>
  );
};

export default PreAssessmentQuestionChatbot;
